
import JigTooltip from '@/components/input/JigTooltip.vue'
import { JigMetadata, UserActivity } from '@/store/modules/jig/types'
import { StandardObject } from '@/store/types'
import { TenantHelpers } from '@/utils/tenant-helpers'
import IconBin from '@svg/IconBin.svg'
import IconCopy from '@svg/IconCopy.svg'
import IconMore from '@svg/IconMore.svg'
import IconOutLink from '@svg/IconOutLink.svg'
import IconShare from '@svg/IconShare.svg'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
  components: {
    IconBin,
    'icon-copy': IconCopy,
    IconMore,
    'icon-out-link': IconOutLink,
    'icon-share': IconShare,
    JigTooltip,
  },
})
export default class MoreModelActionsVue extends Vue {
  @Prop({ type: String, default: '' })
  public customClass!: string
  @Prop({ type: Boolean, default: false })
  public hasThumbnailCustomType!: boolean
  @Prop({ type: String, default: '' })
  public thumbnailURLMapCustomType!: string

  protected mounted() {}

  private uploadThumbnail() {
    this.$emit('on-upload-clicked')
  }

  private deleteModel() {
    this.$emit('on-delete-clicked')
  }
}
